export const FEEDBACK_LIST = 'FEEDBACK_LIST' as const
export const FEEDBACK_ALL = 'FEEDBACK_ALL' as const
export const FEEDBACK_CREATE = 'FEEDBACK_CREATE' as const
export const FEEDBACK_EDIT = 'FEEDBACK_EDIT' as const
export const FEEDBACK_STATUS = 'FEEDBACK_STATUS' as const
export const FEEDBACK_TYPES = 'FEEDBACK_TYPES' as const
export const FEEDBACK_UPDATE = 'FEEDBACK_UPDATE' as const

export const FEEDBACK_FORM = 'FEEDBACK_FORM' as const
export const FEEDBACK_FORM_LIST = 'FEEDBACK_FORM_LIST' as const
export const FEEDBACK_FORM_ALL = 'FEEDBACK_FORM_ALL' as const
export const FEEDBACK_FORM_CREATE = 'FEEDBACK_FORM_CREATE' as const
export const FEEDBACK_FORM_DELETE = 'FEEDBACK_FORM_DELETE' as const

export const GLOBAL_STATE = 'Feedback'
